import React from 'react'
import CloudBody from '../components/cloud/CloudBody'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'

const CloudManagement = () => {
  return (
    <div>
       <Navbar></Navbar>
       <CloudBody></CloudBody>
       <Footer></Footer>
    </div>
  )
}

export default CloudManagement
